import React, {useState} from 'react';
import PropTypes from 'prop-types';

const CoinLogo = ({code, name, label='', ...restProps}) => {
  const [coinLogo, setCoinLogo] = useState(`https://static.coincap.io/assets/icons/${code.toLowerCase()}@2x.png`)

  return (
    <div className="coin-icon">
      <img
        alt={`${name}-icon`}
        src={coinLogo}
        data-testid={code}
        onError={() => setCoinLogo('https://cdn.taxbit.com/img/coins/uknown.svg')}
        {...restProps}
      />
      <span>{label}</span>
    </div>
  )
}

CoinLogo.propTypes = {
  code: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string
}

export default CoinLogo;